import {useCartStore} from "~~/stores/cart";

export default defineNuxtPlugin(async () => {
    const cart = useCartStore()
    if (!cart.cart) {
        try { await cart.fetch() } catch { /* ignore */ }
    }
})

